
import {fixPageAfterDel} from '@/utils/utils'
import { EditModal} from './components'

import columns from './tableConfig'
import {searchItems} from './searchFormConfig'

let searchCache = {}
import { IndustryCreate, IndustryDelete, IndustryUpdate, QueryIndustryList } from '@/apis/industry'



export default {
  name: 'Industry.Index',
  components: {EditModal},
  data() {
    return {
      searchItems,
      searching: false,
      confirmGroupLoading: false,

      columns,
      data: [],
      loading: false,
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100']
      },

      selectIndustry: null,
      showAppInfoModal: false,
      showEditModal: false,

      target: null,
      states : [
        {code: 0, name: '正常'},
        {code: 1, name: '禁用'},
        {code: 2, name: '删除'},
      ],
      templateList:[],
    }
  },
  watch: {
    '$route.params.search': async function(search) {
      if (search) {
        this.setDefaultSearchForm(search)
        this.$refs.searchForm.handlerSearch()
      }
    }
  },
  created() {
    this.$nextTick(async () => {
      const { search } = this.$route.params
      this.$refs.searchForm.handlerSearch()
    })
  },
  methods: {
    async setDefaultSearchForm(data) {
      if (!this.deviceGroupSelections){
        await this.getDeviceGroupSelections()
      }
      if (data) {
        const { groupId } = data
        this.$refs.searchForm.setFieldsValue({ groupId })
        this.$route.params.search = undefined
      }
    },
    // 查询设备
    async getIndustryIndex(page = 1, searchData) {
      try {
        this.loading = true
        // 确定搜索条件
        searchData = searchData || searchCache
        // 缓存搜索条件
        searchCache = searchData
        const {keyword} = searchData
        const {collection: data, pageInfo} = await QueryIndustryList({
          keyword,
          page,
          perPage: this.pagination.pageSize
        })
        this.data = data
        this.pagination.current = page
        this.pagination.total = pageInfo.total
      } catch (error) {
        console.log(error)
      }
      this.loading = this.searching = false
    },
    // 翻页
    handlePageTurn(pagination, filters, sorter) {
      const {current, pageSize} = pagination
      this.pagination.pageSize = pageSize

      this.getIndustryIndex(current)
    },
    queryTemplateName(code){
      return this.templateList.find(item=>item.id === code).name
    },

    // 提交编辑设备的信息
    async handleSubmitEdit(value) {
      let data = Object.assign({},value)
      try {
        const {id} = data
        if (!id) {
          await IndustryCreate(data)
          await this.getIndustryIndex()
        } else {
          await IndustryUpdate(data)
          await this.getIndustryIndex(this.pagination.current)
        }
      } catch (error) {
      }
      this.handlerCloseEditModal()
    },
    // 打开编辑设备模态框
    handlerOpenEditModal(data) {
      let info = null
      if (data){
        info = Object.assign({},data)
      }
      this.target = info
      this.showEditModal = true
    },
    // 关闭编辑设备模态框
    handlerCloseEditModal() {
      this.target = null
      this.showEditModal = false
    },

    // 删除设备
    handlerDeleteIndustry(data) {
      const {id, name} = data
      this.$confirm({
        title: '即将删除行业，信息如下：',
        content: h => h('div', {style: {fontSize: '12px'}}, [
          h('p', {style: {margin: '5px 0 0'}}, `名称：${name || '-'}`)
        ]),
        okText: '删除',
        okType: 'danger',
        cancelText: '取消',
        confirmLoading: true,
        onOk: () => {
          return IndustryDelete(id ).then(() => {
            this.pagination = fixPageAfterDel(this.pagination)
            this.getIndustryIndex(this.pagination.current)
          })
        }
      })
    },

    // 打开编辑设备模态框
    handlerOpenGroupEditModal(data) {
      const { id:deviceId, groupId:deviceGroupId } = data
      this.deviceEditGroupForm = {deviceId, deviceGroupId}
      this.showGroupEditModal = true
    },
    // 关闭编辑设备模态框
    handlerCloseGroupEditModal() {
      this.deviceEditGroupForm = deviceEditGroupForm
      this.showGroupEditModal = false
      this.confirmGroupLoading = false
    },
    handleShowInfo(data){
      this.selectIndustry = data
      this.showAppInfoModal = true
    },
  }
}
